import React, { useEffect } from 'react';
import { ReactFlow, useNodesState, useEdgesState, Background, Controls, MiniMap } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

import { nodeTypes } from './ArchCustomNodes';
import { edgeTypes } from './ArchCustomEdges';
import { getInitialNodes } from './ArchNodes';
import { getInitialEdges } from './ArchEdges';
import { useTranslation } from 'react-i18next';
import './ArchFlow.scss';

// Import the logo for the watermark
import watermarkLogo from '../../../../../images/Logo/Logo HSV_Icon.png';

const ArchFlowContainer = () => {
  const { t, i18n } = useTranslation();
  
  // Use React Flow state hooks
  const [nodes, setNodes, onNodesChange] = useNodesState(getInitialNodes(t));
  const [edges, setEdges, onEdgesChange] = useEdgesState(getInitialEdges());

  useEffect(() => {
    setNodes(getInitialNodes(t));
  }, [i18n.language, t, setNodes]);

  return (
    <div style={{ width: '100%', height: '1000px', backgroundColor: '#f8fafc', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', position: 'relative' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
        fitViewOptions={{ padding: 0.1 }}
        minZoom={0.2}
        maxZoom={2}
        nodesDraggable={false} // Users should just view it
        nodesConnectable={false}
      >
        <Background color="#cbd5e1" gap={20} />
        <Controls />
        <MiniMap zoomable pannable nodeColor="#0b4e96" maskColor="rgba(255, 255, 255, 0.7)" />
      </ReactFlow>

      {/* Faint Watermark Logo (tiled across entire chart) */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        /* Added quotes around the URL to fix CSS bug when filename has spaces */
        backgroundImage: `url("${watermarkLogo}")`,
        backgroundSize: '250px',
        backgroundRepeat: 'repeat',
        opacity: 0.02, /* Reduced from 0.05 to 0.02 to be fainter */
        pointerEvents: 'none',
        zIndex: 9999
      }} />
    </div>
  );
};

export default ArchFlowContainer;
